var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7.5V2.5H12C12.55 2.5 13 2.05 13 1.5C13 0.95 12.55 0.5 12 0.5H2C1.45 0.5 1 0.95 1 1.5C1 2.05 1.45 2.5 2 2.5H3V7.5C3 9.16 1.66 10.5 0 10.5V12.5H5.97V19.5L6.97 20.5L7.97 19.5V12.5H14V10.5C12.34 10.5 11 9.16 11 7.5Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.c2851c19.svg";
export { ForwardRef as ReactComponent };